function firePostMessage(postMessage: unknown) {
  try {
    window.parent.postMessage(postMessage, new URL(document.referrer).origin);
  } catch { /* empty */ }
}

export default firePostMessage;
